// Welcome page entry point - Minimal bundle for homepage

// Essential welcome page functionality
window.questus = window.questus || {};

// Basic loading overlay management
window.questus.hideLoadingOverlay = function() {
  const overlay = document.getElementById('loadingOverlay');
  if (overlay) {
    overlay.style.display = 'none';
  }
  if (document.body) {
    document.body.classList.remove('loading');
  }
};

window.questus.updateOverlayMessage = function(message) {
  const messageElement = document.getElementById('loadingMessage');
  if (messageElement) {
    messageElement.textContent = message;
  }
};

// HTMX event listeners
function addHTMXListeners() {
  document.body.addEventListener('htmx:beforeRequest', () => {
    const overlay = document.getElementById('loadingOverlay');
    if (overlay) overlay.style.display = 'flex';
  });

  document.body.addEventListener('htmx:afterRequest', () => {
    window.questus.hideLoadingOverlay();
  });
}

// Welcome page initialization
async function initWelcomePage() {
  
  // Hide loading overlay
  window.questus.hideLoadingOverlay();
  
  // Add HTMX listeners
  addHTMXListeners();
  
  // Add smooth scrolling for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      const href = this.getAttribute('href');
      
      // Skip if href is just "#" or empty, or if it's a dropdown toggle
      if (!href || href === '#' || this.hasAttribute('data-bs-toggle')) {
        return;
      }
      
      e.preventDefault();
      const target = document.querySelector(href);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });
  
  // Handle "Get Started" CTA buttons
  const ctaButtons = document.querySelectorAll('[data-action="get-started"]');
  ctaButtons.forEach(button => {
    button.addEventListener('click', function() {
      if (window.appContext?.isLoggedIn) {
        window.location.href = '/dashboard';
      } else {
        window.location.href = '/auth/login';
      }
    });
  });
  
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initWelcomePage);
} else {
  initWelcomePage();
}